import { render, staticRenderFns } from "./TopicNdSubtopic.vue?vue&type=template&id=5a5285b4&scoped=true"
import script from "./TopicNdSubtopic.vue?vue&type=script&lang=js"
export * from "./TopicNdSubtopic.vue?vue&type=script&lang=js"
import style0 from "./TopicNdSubtopic.vue?vue&type=style&index=0&id=5a5285b4&prod&scoped=true&lang=css"
import style1 from "./TopicNdSubtopic.vue?vue&type=style&index=1&id=5a5285b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5285b4",
  null
  
)

export default component.exports